export type NotificationType = 'event_invitation' | 'event_reminder' | 'new_badge_earned';

export type Notification = {
    id: number;
    type: NotificationType;
    title: string;
    summary?: string;
    relevant_data?: Record<string, any>;
    created_at: string;
    is_read: boolean;
};

export type LoadableNotification = Notification & {
    loading?: boolean;
};

export enum NotificationTabValues {
    UNREAD = 'unread',
    READ = 'read',
}

export type NotificationSettings = Record<NotificationType, boolean>;
